const API_URL = process.env.REACT_APP_API_URL;

// Helper function to get auth token (add this at the top)
const getAuthToken = () => {
  return localStorage.getItem("authToken") || "";
};

export const debtorDetailsService = {
  // Fetch all documents for a specific case
  async getDebtorDetails(emailId) {
    try {
      const response = await fetch(
        `${API_URL}/api/law_firm/view-lba?email=${encodeURIComponent(emailId)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAuthToken()}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch details");
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching documents:", error);
      throw error;
    }
  },

  async fetchUserSubmissionData(userId) {
    try {
      const response = await fetch(`${API_URL}/api/lba/data/${userId}`, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      });
      const data = await response.json();

      return data.success
        ? {
            success: true,
            count: data.count,
            details: data.details,
            amountRecovered: data.amountRecovered,
          }
        : { success: false, error: "Failed to fetch data" };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  async markAsSettled(lbaId, userId) {
    try {
      const response = await fetch(
        `${API_URL}/api/lba/updatedstatus/${lbaId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAuthToken()}`,
          },
          body: JSON.stringify({
            status: "Settled", // Frontend sends "Settled"
            userId,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Failed to update status");
      }

      // Map "Resolved" to "Settled" in the response
      return {
        ...data,
        status: data.status === "Resolved" ? "Settled" : data.status,
      };
    } catch (error) {
      console.error("Error marking as settled:", error);
      throw error;
    }
  },

  async getLbaStatus(lbaId, userId) {
    try {
      const response = await fetch(`${API_URL}/api/lba/status/${lbaId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAuthToken()}`,
        },
      });

      const data = await response.json();
     

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Failed to fetch status");
      }

      // Map "Resolved" to "Settled" for the UI
      return {
        ...data,
        status: data.status === "Resolved" ? "Settled" : data.status,
        lawyerId:data.lawyerId,
        clientName:data.companyName
      };
    } catch (error) {
      console.error("Error fetching LBA status:", error);
      // Return default status if fetch fails
      return { success: false, status: "Unsettled" };
    }
  },
  // Add to debtorDetailsService.js

  async getCommunicationHistory(lbaId) {
    try {
      const response = await fetch(
        `${API_URL}/api/lba/communication-history/${lbaId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAuthToken()}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch communication history");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching communication history:", error);
      throw error;
    }
  },
};
